var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 58,
    viewBox: "0 0 48 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 25.1333C48 38.28 40.3717 44.37 34.9662 48.6852C32.6252 50.5605 30.6978 52.0956 30 53.7312C29.0031 56.0667 26.9095 58 24 58C21.0905 58 19.0006 56.0667 18 53.7312C17.2985 52.0956 15.3785 50.5605 13.0302 48.6852C7.62831 44.37 0 38.2761 0 25.1333C0 18.4676 2.52856 12.0748 7.02944 7.36138C11.5303 2.64797 17.6348 0 24 0C30.3652 0 36.4697 2.64797 40.9706 7.36138C45.4714 12.0748 48 18.4676 48 25.1333ZM29.5385 25.1333C29.5385 26.6716 28.9549 28.1468 27.9163 29.2346C26.8776 30.3223 25.4689 30.9333 24 30.9333C22.5311 30.9333 21.1224 30.3223 20.0837 29.2346C19.0451 28.1468 18.4615 26.6716 18.4615 25.1333C18.4615 23.5951 19.0451 22.1198 20.0837 21.0321C21.1224 19.9444 22.5311 19.3333 24 19.3333C25.4689 19.3333 26.8776 19.9444 27.9163 21.0321C28.9549 22.1198 29.5385 23.5951 29.5385 25.1333Z",
    fill: "#FF3B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHere);
export default __webpack_public_path__ + "static/media/here.12b0b659fd23f50d3741886f502804c6.svg";
export { ForwardRef as ReactComponent };